import { partnerAdminFetch } from '~/api/partnerAdminFetch';
import { ApiError } from '../../action/apiError';
import {
  ClientAdminUserType,
  clientAdminUserSearchParams,
} from '../../types/resources/ClientAdminUserType';

const endpoint = '/partner_admins/client_admin_users';

type GetResponseType = {
  data: {
    client_admin_users: ClientAdminUserType[];
  };
  headers: Record<string, string>;
};

export async function getClientAdminUsers(
  signOut: () => void,
  searchParams?: clientAdminUserSearchParams
): Promise<GetResponseType> {
  const queryString = new URLSearchParams(searchParams).toString();
  const response = await partnerAdminFetch(
    `${endpoint}${queryString ? `?${queryString}` : ''}`,
    {
      method: 'GET',
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return {
    data,
    headers: Object.fromEntries(response.headers.entries()),
  };
}

export async function createClientAdminUser(
  data
): Promise<{ client_admin_user: ClientAdminUserType }> {
  const response = await partnerAdminFetch(endpoint, {
    method: 'POST',
    data: data,
  });

  if (!response.ok) {
    const errorDetails = await response.json();
    throw new ApiError(
      `HTTP ${response.status} ${response.statusText}`,
      errorDetails.errors || [errorDetails.message]
    );
  }

  return response.json();
}
